export default __webpack_public_path__ + "static/media/DesligadaAlarme.b709c39c.svg";